import { mapValues, merge } from 'lodash';

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
function fixLineHeight(obj) {
  return __spreadValues(__spreadValues({}, mapValues(obj, (value) => {
    return typeof value === "object" && value !== null ? fixLineHeight(value) : value;
  })), obj.fontSize !== void 0 && obj.lineHeight === void 0 ? { lineHeight: 1.5 } : {});
}
function toVars(customStyles, prefix = "", separator = "-") {
  const propertyNames = {};
  function traverseObject(currentObj, currentPath = "") {
    for (const [key, value] of Object.entries(currentObj)) {
      const fullPath = currentPath ? `${currentPath}${separator}${key}` : key;
      if (typeof value === "object") {
        traverseObject(value, fullPath);
      } else {
        propertyNames[`${prefix ? prefix + "-" : ""}${fullPath}`] = value;
      }
    }
  }
  traverseObject(customStyles);
  return propertyNames;
}
const createCustomStyles = ({
  customStyles = {},
  settingsStyles = {},
  nativeStyle = {}
}) => {
  return merge(
    {},
    toVars(fixLineHeight(customStyles), "custom"),
    toVars(settingsStyles, "settings"),
    toVars(nativeStyle, "native")
  );
};

export { createCustomStyles as default, fixLineHeight, toVars };
//# sourceMappingURL=customStyles.js.map
